import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import {
  GET_EOD_DAILY_REPORT,
  SEND_MAIL_EOD_REPORT,
  baseUrl,
} from "../../../helpers/url_api_constant";
import { Link, useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";

import BootstrapTable from "react-bootstrap-table-next";
import { DatePicker } from "antd";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import Select from "react-select";
import classnames from "classnames";
import { connect } from "react-redux";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";

//i18n

function EODSummaryReport(props) {

  let history = useHistory();

  const dispatch = useDispatch();
  const permission = getPermission();
  const toGasDate = moment().add(-1, 'day');

  // console.log(toGasDate);

  const searchObj = { MONTH_YEAR: moment(new Date(toGasDate.year(), 0, 1)), TO_MONTH_YEAR: moment(new Date(toGasDate.year(), 11, 1)), };

  // const searchObj = { MONTH_YEAR: null, TO_MONTH_YEAR: null };
  // const createObj = { UPLOAD_DESC: "", };

  // const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");

  // DropDown Search
  const [dropDownSearchType, setDropDownSearchType] = useState(null);
  // DropDown Search

  // Handle Set Value DropDown Search //
  const handleSelectDropDownSearchType = selected => {
    setDropDownSearchType(selected);
  };
  // Handle Set Value DropDown Search //

  const listData = [
    {
      PID: "1",
      GAS_DAY: "01/04/2022",
      FLOW_STATUS: "Approve",
      SUMMARY_REV: "Rev.1",
    },
    {
      PID: "2",
      GAS_DAY: "02/04/2022",
      FLOW_STATUS: "Approve",
      SUMMARY_REV: "Rev.1",
    },
    {
      PID: "3",
      GAS_DAY: "03/04/2022",
      FLOW_STATUS: "Approve",
      SUMMARY_REV: "Rev.2",
    },
    {
      PID: "4",
      GAS_DAY: "04/04/2022",
      FLOW_STATUS: "Approve",
      SUMMARY_REV: "Rev.1",
    },
    {
      PID: "5",
      GAS_DAY: "05/04/2022",
      FLOW_STATUS: "Approve",
      SUMMARY_REV: "Rev.2",
    },
    {
      PID: "6",
      GAS_DAY: "06/04/2022",
      FLOW_STATUS: "Approve",
      SUMMARY_REV: "Rev.1",
    },
    {
      PID: "7",
      GAS_DAY: "07/04/2022",
      FLOW_STATUS: "Approve",
      SUMMARY_REV: "Rev.1",
    },
    {
      PID: "8",
      GAS_DAY: "08/04/2022",
      FLOW_STATUS: "Edit",
      SUMMARY_REV: "Changed",
    },
  ];

  const listType = [
    { label: "Excel", value: "Excel" },
    { label: "PMIS", value: "PMIS" },

    // { label: "Refresh Manual PMIS", value: "Refresh Manual PMIS" },
    // { label: "Auto load PMIS", value: "Auto load PMIS" },
  ];

  //sort Column//
  const defaultSorted = [
    {
      dataField: "MONTH_YEAR",
      order: "desc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "750",
        value: 750,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  // Action Button//
  const ButtonAction = (cellContent, row) => {
    // console.log(row)
    return (
      <div>
        {permission.vEOD && (
          <>
            <OverButton
              onClick={() => {
                downloadExcel(row);
              }}
              color="success"
              icon="fas fa-file-download fa-lg"
              label="Download Excel"
            />
            <OverButton
                onClick={() => {
                  dispatch(
                    confirmAction.showConfirm(
                      "Do you want to send e-mail ?",
                      () => {
                        sendMail(row);
                      }
                    )
                  );
                }}
              // onClick={() => {
              //   sendMail(row);
              // }}
              color="info"
              icon="mdi mdi-email-send fa-lg"
              label="Send E-mail"
            />
          </>
        )}
      </div>
    );
  };

  // useEffect(function () {

  //   let UPLOADTYPE_NAME = dropDownSearchType != null ? dropDownSearchType.value : null;

  //   setSearchModel(preVent => ({
  //     ...preVent, UPLOADTYPE_NAME: UPLOADTYPE_NAME
  //   }));
  // }, [dropDownSearchType]);

  // Action Button//

  const downloadExcel = async (row) => {
    // console.log(row);
    dispatch(loadingAction.showLoading());
    const accessToken = JSON.parse(localStorage.getItem("accessToken"));
    fetch(baseUrl + "api/Report/downloadExcelEODReport?SELECT_DATE=" + moment(row.MONTH_YEAR).format("YYYY-MM"), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/zip',  ///vnd.ms-excel
        'Authorization': "Bearer " + accessToken.access_token,
        'TSOSESSIONID': getUserToken(),
      },
    })
      // fetch("https://tsoopwb.pttplc.com/api/DownloadFile/DownloadBookingFile?szFileName=" + pid , {
      //   method: 'GET',
      //   headers: {
      //     'Content-Type': 'application/vnd.ms-excel',
      //     'Authorization':"Bearer " + accessToken.access_token
      //   },
      // })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          // `FileName.xlsx`,
          'EOD_Report_' + moment(row.MONTH_YEAR).format("MM-YYYY") + '.zip'
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
        dispatch(loadingAction.hideLoading());
      });

  };

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  //format date 
  const FormatDate = (date, format) => {
    return (
      <div>
        {moment(date).format(
          format
        )}
      </div>
      // Sep-21
    );
  };
  //format date

  //Check active
  const CheckActive = (active) => {
    // console.log(type);
    let status = "";
    let color = "";

    if (active == 1) {
      status = "Active";
      color = "success";
    } else {
      status = "-";
      color = "";
    }

    return (
      <div>
        <span className={"badge badge-soft-" + color} style={{ fontSize: 12 }}>
          {status}
        </span>
      </div>
    );
  };
  //Check active

  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
      formatter: CountIndexRow,
    },

    {
      dataField: "MONTH_YEAR",
      text: "Gas Day",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "25%",
        fontSize: "12px",
      },
      style: {
        width: "25%",
        fontSize: "12px",
      },
      sort: true,
      isDummyField: true,
      formatter: (cellContent, row) => FormatDate(row.MONTH_YEAR, "MM-YYYY"),
    },

    // {
    //   dataField: "STATUS_FLAG",
    //   text: "Status",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {},
    //   sort: true,
    //   isDummyField: true,
    //   formatter: (cellContent, row) => CheckActive(row.STATUS_FLAG),
    // },

    {
      dataField: "df1",
      text: "Action",
      isDummyField: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
      formatter: ButtonAction,
    },
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    resetSearch();
    // resetModel();
    // setModelDeviceList(listData);
    let tableId = "viewer-eod-table";
    let scrollY = 213;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
  }, []);
  //onInit//

  const resetSearch = () => {
    setSearchModel(searchObj);
    fetchData(searchObj);
  };

  const resetModel = () => {
    setCreateModel(createObj);

  };

  const onSearch = () => {
    fetchData(searchModel);
  };

  const fetchData = async (searchData) => {
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_EOD_DAILY_REPORT, { ...searchData, MONTH_YEAR: moment(searchData.MONTH_YEAR).format("YYYY-MM"), TO_MONTH_YEAR: moment(searchData.TO_MONTH_YEAR).format("YYYY-MM") });
      // console.log(res);
      // setModelDeviceList(res.data.rpEODList);
      setModelDeviceList(res.data.rpEODList.map(obj => ({
        ...obj,
        MONTH_YEAR: moment(obj.MONTH_YEAR).toDate()
      }
      ))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const sendMail = async (data) => {
    // console.log(data);
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(SEND_MAIL_EOD_REPORT, { ...data, MONTH_YEAR: moment(data.MONTH_YEAR).format("YYYY-MM") });
      if (res.resultCode != 200) {
        dispatch(messageAction.showMessage(res.resultDescription));
      } else {
        dispatch(messageAction.showMessage("Sending email."));
        fetchData(searchModel);
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      {props.t("EOD Summary")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Report Viewer
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">EOD Summary</li>
                      </ol>
                    </div>
                  </div>
                </CardBody>
              </Card>

              <Row>
                <Col sm="12">
                  <Card>
                    <CardBody>

                      <Row>
                        <Col sm="4">
                          <FormGroup className="row mt-0">
                            <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                              Start Data Date
                            </Label>
                            <Col sm={8}>
                              <DatePicker
                                style={{ width: 235, height: 38, marginLeft: 0 }}
                                // defaultValue={moment(dateSelected)}
                                format={"MMM YYYY"}
                                placeholder="Select Month"
                                onChange={(date, dateString) => {
                                  // console.log(date)
                                  if (date != null) {
                                    setSearchModel({
                                      ...searchModel,
                                      MONTH_YEAR: date,
                                    });
                                  }
                                }}
                                picker="month"
                                value={searchModel.MONTH_YEAR}
                              // disabledDate={disabledDate}
                              />
                              {/* 
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                options={{
                                  altInput: true,
                                  // altFormat: "d/m/Y",
                                  altFormat: "d/m/Y",
                                  dateFormat: "d/m/Y",
                                }}
                                onChange={(value) => {
                                  setSearchModel(
                                    {
                                      ...searchModel,
                                      MONTH_YEAR: value[0]

                                    })
                                }}
                                value={searchModel.MONTH_YEAR}
                              /> */}
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col sm="4">
                          <FormGroup className="row mt-0">
                            <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                              End Data Date
                            </Label>
                            <Col sm={8}>
                              <DatePicker
                                style={{ width: 235, height: 38, marginLeft: 0 }}
                                // defaultValue={moment(dateSelected)}
                                format={"MMM YYYY"}
                                placeholder="Select Month"
                                onChange={(date, dateString) => {
                                  // console.log(date)
                                  if (date != null) {
                                    setSearchModel({
                                      ...searchModel,
                                      TO_MONTH_YEAR: date,
                                    });
                                  }
                                }}
                                picker="month"
                                value={searchModel.TO_MONTH_YEAR}
                              // disabledDate={disabledDate}
                              />

                              {/* <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                options={{
                                  altInput: true,
                                  // altFormat: "d/m/Y",
                                  altFormat: "d/m/Y",
                                  dateFormat: "d/m/Y",
                                }}
                                onChange={(value) => {
                                  setSearchModel(
                                    {
                                      ...searchModel,
                                      TO_MONTH_YEAR: value[0]

                                    })
                                }}
                                value={searchModel.TO_MONTH_YEAR}
                              /> */}
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col sm="4">
                          <FormGroup className="row">
                            <div className="d-flex align-items-center justify-content-center">
                              <Button color="info" className="mt-0"
                                onClick={() => onSearch()}
                              >
                                <i className="fas fa-search"></i>
                                &nbsp; Search
                              </Button>

                              <Button color="warning" className="mt-0 ms-2"
                                onClick={() => resetSearch()}
                              >
                                <i className="fas fa-redo-alt"></i>
                                &nbsp; Reset
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>

                      {/* <Row className="mt-5">
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "1",
                              })}
                              onClick={() => {
                                setActiveTab("1");
                              }}
                            >
                              EOD Summary
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Row> */}

                      <Row className="mt-4">
                        <hr />
                      </Row>

                      <Row className="mt-0">
                        {/* <TabContent
                          activeTab={activeTab}
                          className="p-3 text-muted"
                        >
                          <TabPane tabId="1"> */}

                        <Col sm="12">
                          <div>
                            <BootstrapTable
                              id="viewer-eod-table"
                              keyField="MONTH_YEAR"
                              data={modelDeviceList}
                              columns={columns}
                              headerClasses="header-style"
                              rowStyle={rowStyleFontWhite}
                              defaultSorted={defaultSorted}
                              pagination={paginationFactory(options)}
                            // hover
                            />
                          </div>
                        </Col>

                        {/* </TabPane>
                        </TabContent> */}
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>

          </Row>
        </Container>

      </div>
    </React.Fragment>
  );
}

EODSummaryReport.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ EODSummaryReport }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(EODSummaryReport));

// function RenderList(prop) {
//   console.log(prop);

//   return (<tr>
//     <td>{prop.indexlist}</td>
//     <td>{prop.data.MeterPointID}</td>
//     <td>{prop.data.Customer}</td>
//     <td>{prop.data.CustomerType}</td>
//     <td>{prop.data.CommunicationType}</td>
//     <td>{prop.data.Zone}</td>
//     <td>{prop.data.Point}</td>
//     <td>{prop.data.Region}</td>
//     <td>{prop.data.Area}</td>
//     <td>{prop.data.BVZoning}</td>
//     <td>{prop.data.BV}</td>
//     <td>
//       <Button className="me-1"
//         onClick={() =>
//           setPageAdd(true)
//         }
//         color="info"
//       >
//         <i className="far fa-edit"></i>
//         &nbsp; Edit
//       </Button>
//       <Button
//         onClick={() =>
//           setModalDelete(true)
//         }
//         // className="btn-rounded"
//         color="danger"
//       >
//         <i className="fas fa-trash-alt"></i>
//         &nbsp; Delete
//       </Button>
//     </td>
//   </tr>)
// }
